import { Component, OnDestroy, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { AlertService, CoreService, ReportsService, UploadExamCenterService } from 'src/app/shared';
import { TestbatchService } from 'src/app/shared/services/test-batch/testbatch.service';
import {UploadTestTimingService}  from 'src/app/shared/services/upload-test-timing/upload-test-timing.service';
import { Observable } from "rxjs/Observable";
import * as moment from 'moment';
import 'rxjs/add/observable/timer';
import { take } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';
@Component({
  selector: 'app-exam-status',
  templateUrl: './exam-status.component.html',
  styleUrls: ['./exam-status.component.scss']
})
export class ExamStatusComponent implements OnInit, OnDestroy {

  filter:any = {};
  report:any = {};
  rows:any = [];
  batches:any  = [];
  cities:any = [];
  centers: any = [];

  tabular  = false;
  timings:any = [];

  countDown:any;
  timer: any;
  timerSubs: any;
  interval = 30;
  counter = 30;
  tick = 1000;
  showVerification = false;
  showExamProgress = false;
  selectedCenter: any;
  selectedBatch: any;
  verificationStatusFilter = 'all';
  examProgressType = 'appearing';


  constructor(
    private alert:AlertService,
    private core:CoreService,
    private uploadTestTimingService: UploadTestTimingService,
    private testbatchService: TestbatchService,
    private examCenterService : UploadExamCenterService,
    private reportService: ReportsService) { }

  ngOnInit() {
    this.getBatch ();
    this.initCounter ();
    this.getAllTimings ();
    this.getCenters (); 
  }

  ngOnDestroy (){
    if (this.timerSubs){
      this.timerSubs.unsubscribe ();
    }
  }

  getAllTimings (){
    this.uploadTestTimingService.getTestTimingByBatch ("ALL")
   .pipe (first())
   .subscribe (res =>{
    this.timings = res ||[];
   });
  }

  getBatch() {
    this.testbatchService.getAll()
    .pipe(first())
    .subscribe(res => {
      this.batches = res;
    })
  }


   


  getCenters() {
    this.examCenterService.searchExamCenterList (1, 10000, {})
    .pipe(first())
    .subscribe(res => {
     var temp:any = res || {data:[]};
     this.centers = temp.data;
      this.cities = [];
      var x = {};
      for (var i=0; i<this.centers.length; i++){
        var ctr = this.centers [i];
        var obj  = {
          center_city_code: ctr.center_city_code,
          center_city_name: ctr.center_city_name
        }
        if (!x [obj.center_city_code]){
           this.cities.push (obj);
           x [obj.center_city_code] = true;
        }
       
      }
    })
  }

  getTiming (row){
   // console.log ("row", row);
    if (this.timings && this.filter && this.filter.batch){
      var x = this.timings.find (x => x.center_id == row.center_id &&  x.batch_id == this.filter.batch.code);
      if (x){
        return x.test_date  + " " + x.test_start_time.hour + ":"+ x.test_start_time.minute;
      }
    }
    return "--";
  }

  getReport (){
    this.counter  = this.interval;
    this.reportService.getExamStatus (this.filter)
    .pipe (first())
    .subscribe ( (res:any) =>{

      if (res && res.status == "error"){
       // this.alert.err (res.message);
        return;
      }
      this.report = res || {};
      this.rows = this.report.rows || [];
      for (var i=0; i<this.rows.length; i++){
        this.rows [i].timing = this.getTiming (this.rows [i]);
      }
    });
  }

  toggleFullScreen (){
    this.core.toggleScreen ();
  }



  initCounter (){
    
    --this.counter;
    if (this.counter <5){
      this.getReport ();
     
    }

    setTimeout(() => {
      this.initCounter ();
    }, this.tick);

  //   this.initCounter ();
  //   this.timer = Observable.timer(0, this.tick);
  //   this.timerSubs = this.timer.subscribe ();
    
  //   this.countDown = this.timer.take(this.counter)
  //             .map(() => { 
  //               --this.counter; 
                
  //               if (this.counter <5){
                 
  //                 this.getReport ();
  //               }
                
                
  //               return this.counter;
                
  //   });
  }

  openVerification(row: any, status: string) {
    this.showExamProgress = false;
    this.selectedBatch = row.batch_id;
    this.selectedCenter = row.center_id;
    this.verificationStatusFilter = status || 'all'; 
 
    this.showVerification = !!(this.selectedCenter && this.selectedBatch);
  }

  openExamProgress(row: any, type: string) {
    this.showVerification = false;
    this.selectedBatch = row.batch_id;
    this.selectedCenter = row.center_id;
    this.examProgressType = type || 'appearing';
    this.showExamProgress = !!(this.selectedCenter && this.selectedBatch);
  }

  closeVerification() {
    this.showVerification = false;
  }

  closeExamProgress() {
    this.showExamProgress = false;
  }

  clearDashboard() {
    const confirmed = confirm('This will clear dashboard data and should be used for testing only. Do you want to continue?');
    if (!confirmed) {
      return;
    }

    this.reportService.clearDashboard()
    .pipe(first())
    .subscribe({
      next: () => {
        this.alert.show('Exam Status', 'Dashboard test data cleared.');
        this.getReport();
      },
      error: () => {
        this.alert.err('Exam Status', 'Unable to clear dashboard test data.');
      }
    });
  }

}
